(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("ReactDOM"), require("ReactRouter"), require("mobx"), require("mobxReact"), require("weaPortal"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "ReactDOM", "ReactRouter", "mobx", "mobxReact", "weaPortal"], factory);
	else if(typeof exports === 'object')
		exports["weaPortal"] = factory(require("React"), require("ReactDOM"), require("ReactRouter"), require("mobx"), require("mobxReact"), require("weaPortal"));
	else
		root["weaPortal"] = factory(root["React"], root["ReactDOM"], root["ReactRouter"], root["mobx"], root["mobxReact"], root["weaPortal"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_65__, __WEBPACK_EXTERNAL_MODULE_75__, __WEBPACK_EXTERNAL_MODULE_104__, __WEBPACK_EXTERNAL_MODULE_105__, __WEBPACK_EXTERNAL_MODULE_292__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition